import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);

  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }

  return date1Number - date2Number;
}
function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
export const caseInsensitiveComparator = (valueA, valueB) => {
  let sortOrder = 1;
  const lowercaseA = valueA?.trim()?.toLowerCase();
  const lowercaseB = valueB?.trim()?.toLowerCase();
  if (lowercaseA === lowercaseB) {
    sortOrder = 0;
  } else if (lowercaseA < lowercaseB) {
    sortOrder = -1;
  }
  return sortOrder;
};
export const checkTableHead = [
  {
    headerName: 'Check Log Number',
    field: 'checkLogNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    sort: 'asc',
    minWidth: 200,
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch Number',
    field: 'batchNum',
    cellRenderer: 'batchNumRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'frr-ellipsis-text',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Number',
    field: 'checkNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'CCN',
    field: 'checkIdentifier',
    cellRenderer: 'ccnRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellClass: 'frr-ellipsis-text',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Payee',
    field: 'checkPayeeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Issuer',
    field: 'checkIssuer',
    cellRenderer: 'checkIssuerRender',
    comparator: caseInsensitiveComparator,

    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellClass: 'frr-ellipsis-text',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Check Date',
    field: 'checkDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Postmarked Date',
    field: 'postmarkedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Received Date',
    field: 'receivedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Suspended Date',
    field: 'suspendedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch Date',
    field: 'batchDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Amt',
    field: 'checkAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    cellRenderer: 'CheckAmtCellRender',
    dataAlignRight: true,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    // exportZeroesTwo: true,
    printPrefixValue: '',
    comparator: amountComparator,
    filter: 'agNumberColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Allocated Amt',
    field: 'totAllocatedAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_250,
    cellRenderer: 'TotAllocatedAmtCellRender',
    cellEditor: MaxLengthNumericEditor,
    dataAlignRight: true,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    comparator: amountComparator,
    printPrefixValue: '',
    filter: 'agNumberColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Information',
    field: 'checkInfo',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Not for Drug Rebate',
    field: 'notDrugRebateInd',
    cellRenderer: 'CheckBox',
    showCheckboxIcon: true,
    enableMenu: false,
    minWidth: 200,
    editable: false,
    suppressMenu: false,
    sortable: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_1,
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Payment Type',
    field: 'paymentMediaTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoice Reconcilication',
    field: 'invRecFormatCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const checkTableWithOutCCNHead = [
  {
    headerName: 'Check Log Number',
    field: 'checkLogNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    sort: 'asc',
    minWidth: 200,
    excelAlignment: 'right',

    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch Number',
    field: 'batchNum',
    cellRenderer: 'batchNumRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellClass: 'frr-ellipsis-text',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Number',
    field: 'checkNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Payee',
    field: 'checkPayeeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Issuer',
    field: 'checkIssuer',
    cellRenderer: 'checkIssuerRender',
    comparator: caseInsensitiveComparator,

    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellClass: 'frr-ellipsis-text',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Check Date',
    field: 'checkDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Postmarked Date',
    field: 'postmarkedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Received Date',
    field: 'receivedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Suspended Date',
    field: 'suspendedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch Date',
    field: 'batchDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Amt',
    field: 'checkAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    cellRenderer: 'checkAmtRender',
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    printPrefixValue: '',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agNumberColumnFilter',
    comparator: amountComparator,
    filterParams: {
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Allocated Amt',
    field: 'totAllocatedAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_250,
    cellRenderer: 'totAllocatedAmtRender',
    comparator: amountComparator,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    printPrefixValue: '',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agNumberColumnFilter',
    dataAlignRight: true,
    filterParams: {
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Information',
    field: 'checkInfo',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Not for Drug Rebate',
    field: 'notDrugRebateInd',
    cellRenderer: 'CheckBox',
    enableMenu: false,
    minWidth: 200,
    editable: false,
    suppressMenu: false,
    sortable: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_1,
  },
  {
    headerName: 'Payment Type',
    field: 'paymentMediaTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoice Reconcilication',
    field: 'invRecFormatCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const checkTableWithOutBatchHead = [
  {
    headerName: 'Check Log Number',
    field: 'checkLogNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    sort: 'asc',
    minWidth: 200,
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Number',
    field: 'checkNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'CCN',
    field: 'checkIdentifier',
    cellRenderer: 'ccnRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellClass: 'frr-ellipsis-text',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Payee',
    field: 'checkPayeeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Issuer',
    field: 'checkIssuer',
    cellRenderer: 'checkIssuerRender',
    comparator: caseInsensitiveComparator,

    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellClass: 'frr-ellipsis-text',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Check Date',
    field: 'checkDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Postmarked Date',
    field: 'postmarkedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Received Date',
    field: 'receivedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Suspended Date',
    field: 'suspendedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Amt',
    field: 'checkAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    cellRenderer: 'checkAmtRender',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    printPrefixValue: '',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agNumberColumnFilter',
    comparator: amountComparator,
    filterParams: {
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Allocated Amt',
    field: 'totAllocatedAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'totAllocatedAmtRender',
    comparator: amountComparator,
    maxLength: Styles.Length_10,
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    printPrefixValue: '',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agNumberColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Information',
    field: 'checkInfo',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,

    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Not for Drug Rebate',
    field: 'notDrugRebateInd',
    cellRenderer: 'CheckBox',
    showCheckboxIcon: true,
    enableMenu: false,
    minWidth: 200,
    editable: false,
    suppressMenu: false,
    sortable: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_1,
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Payment Type',
    field: 'paymentMediaTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoice Reconcilication',
    field: 'invRecFormatCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const checkTableWithOutBatchCCNHead = [
  {
    headerName: 'Check Log Number',
    field: 'checkLogNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    sort: 'asc',
    minWidth: 200,
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Number',
    field: 'checkNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Payee',
    field: 'checkPayeeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Issuer',
    field: 'checkIssuer',
    cellRenderer: 'checkIssuerRender',
    comparator: caseInsensitiveComparator,

    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellClass: 'frr-ellipsis-text',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Check Date',
    field: 'checkDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Postmarked Date',
    field: 'postmarkedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Received Date',
    field: 'receivedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Suspended Date',
    field: 'suspendedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Amt',
    field: 'checkAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'checkAmtRender',
    cellEditor: MaxLengthNumericEditor,
    comparator: amountComparator,
    maxLength: Styles.Length_10,
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    printPrefixValue: '$ ',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agNumberColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Allocated Amt',
    field: 'totAllocatedAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_250,
    cellRenderer: 'totAllocatedAmtRender',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    printPrefixValue: '',
    comparator: amountComparator,
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agNumberColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Information',
    field: 'checkInfo',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellClass: 'frr-ellipsis-text',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Not for Drug Rebate',
    field: 'notDrugRebateInd',
    cellRenderer: 'CheckBox',
    showCheckboxIcon: true,
    enableMenu: false,
    minWidth: 200,
    editable: false,
    suppressMenu: false,
    sortable: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_1,
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Payment Type',
    field: 'paymentMediaTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoice Reconcilication',
    field: 'invRecFormatCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const viewHistoryTableHead = [
  {
    headerName: 'Timestamp',
    field: 'timestamp',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 215,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'User',
    field: 'user',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 120,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Activity',
    field: 'activity',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 140,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'ColumnName',
    field: 'columnName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 180,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'BeforeValue',
    field: 'beforeValue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 160,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'AfterValue',
    field: 'afterValue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 160,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    // cellClass: ['marginData'],
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellStyle: { 'margin-top': '13px !important' },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
